import { FormActions } from "../../components/common/FormActions";
import { TTableColumn } from "../../types/common";
import {
  APPROVED,
  RECOMMENDED_FOR_APPROVAL,
  REJECTED,
  SUBMITTED,
} from "../../utils/constants";
import {
  createSelectItem,
  createViewEdit,
  displayDocuments,
  formatDate,
  numberFormat,
} from "../../utils/helpers";
import { sourceApis } from "../handlers/useApiHandler";

export const useRequisition = () => {
  const tableColumns = (): TTableColumn[] => [
    { id: "requisition_date", header: "Requisition Date" },
    { id: "department", header: "Department" },
    { id: "amount", header: "Amount" },
    { id: "actions", header: "Actions" },
  ];

  const tableData = (data: any) =>
    data.map((item: any) => ({
      ...item,
      requisition_date: formatDate(item?.requisition_date),
      actions: (
        <FormActions actions={createViewEdit("/requisitions", item?.id)} />
      ),
    }));

  const viewData = (item: any) => {
    return {
      sections: [
        {
          title: "Requisitions Information",
          fields: {
            requisition_date: formatDate(item?.requisition_date),
            department: item?.department_name,
            purpose: item?.purpose,
            amount: numberFormat(item?.amount),
            status: item?.status,
            created_at: formatDate(item?.created_at),
            updated_at: formatDate(item?.updated_at),
          },
        },
        {
          title: "Supporting Documents",
          fields: displayDocuments(item?.requisition_attachments),
        },
      ],
    };
  };

  return { tableColumns, tableData, viewData };
};

export function useRequisitionActions({ form, data }) {
  let actionsList = [RECOMMENDED_FOR_APPROVAL, APPROVED, REJECTED];

  if (data?.status === SUBMITTED) {
    actionsList = [RECOMMENDED_FOR_APPROVAL, REJECTED];
  } else if (data?.status === RECOMMENDED_FOR_APPROVAL) {
    actionsList = [APPROVED, REJECTED];
  }

  const actions = [...actionsList.map((action) => createSelectItem(action))];

  const fields = [
    {
      field_name: "status",
      type: "select",
      props: { required: true },
      options_data: actions,
      visible: data?.status !== APPROVED,
    },
    {
      field_name: "comment",
      label: "comment",
      type: "textarea",
    },
  ];

  function onSubmit(payload: any, id: any) {
    if (id) {
      let api = sourceApis["requisitions"];

      if (!api) return;
      return {
        id,
        api,
        params: { ...payload },
      };
    }
  }
  const enableSubmit = Object.keys(form).length > 0;
  const finalStates = [APPROVED, REJECTED];

  return { fields, onSubmit, enableSubmit, finalStates };
}
